import type { Point } from 'geojson';

import type { Report } from '@/modules/api';
import type { ReportFeature } from '@/types/ReportFeature';

export class Format {
  public static point(geometry: Point) {
    return `${geometry.coordinates[1]?.toLocaleString('en-US', { maximumFractionDigits: 6 })}, ${geometry.coordinates[0]?.toLocaleString('en', { maximumFractionDigits: 6 })}`;
  }

  private static makeReportTitle(
    report: Pick<Report, 'geometry'> & {
      address?: string | null;
      routeSignLocationId?: string | null;
    },
  ) {
    return report.routeSignLocationId ?? report.address ?? Format.point(report.geometry);
  }

  public static reportTitle(report: Report | ReportFeature) {
    if ('properties' in report) {
      return Format.makeReportTitle({ geometry: report.geometry, ...report.properties });
    }

    return Format.makeReportTitle(report);
  }
}
